import api from "../config/api";

export const fetchAllCategory = async () => {
  const res = await api.get("/category/");
  return res.data.data;
};

export const fetchCategoryById = (id) => {
  const res = api.get(`category/${id}`);
};

export const createCategory = async (formData) => {
  const res = await api.post(`/category/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const updateCategory = async (id, formData) => {
  const res = await api.post(`/category/?id=${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deleteCategory = async (id) => {
  const res = await api.delete(`/category/?id=${id}`);
  return res.data;
};
